// Sprint 32.0 hotfix — moved from pages/admin/planBuilderGroups.js to a shared lib
// location so both the admin Plan Builder AND the tenant-facing "Mi Plan"
// page use the exact same friendly labels — a prior gap flagged by the user.
// Sprint 30.1 — Grupos de negocio para el Plan Builder.
// Traduce los ~80 entitlements/límites técnicos del backend a categorías que
// un Platform Owner sin trasfondo técnico pueda relacionar con lo que
// realmente le está vendiendo/limitando a sus clientes.

export const MODULE_LABELS = {
  crm: 'CRM', agenda: 'Agenda', dashboard: 'Dashboard', reports: 'Reportes',
  marketing: 'Marketing', pos: 'Punto de venta', inventory: 'Inventario',
  ai_chat: 'IA por chat', ai_voice: 'IA por llamada', integrations: 'Integraciones',
  billing: 'Facturación', ai_training: 'Entrenamiento IA', knowledge: 'Biblioteca IA',
  ai_skills: 'Habilidades IA', ai_tools: 'Herramientas IA', mcp: 'Conectores MCP',
  social: 'Redes sociales y anuncios',
  web: 'Sitio web',
  real_estate: 'Desarrollos inmobiliarios',
};

export const PLAN_GROUPS = [
  {
    key: 'mostrador',
    label: 'Cobro en mostrador',
    help: 'Si el negocio le cobra a su cliente estando enfrente: la caja del dia y, mas arriba, todo lo demas.',
    defaultOpen: false,
    entitlements: [
      { key: 'pos_enabled', label: 'Caja: cobrar en efectivo y cerrar el dia' },
      { key: 'pos_advanced_enabled', label: 'Punto de Venta completo (cobro a distancia, devoluciones, membresias, terminal)' },
    ],
    limits: [],
    advancedEntitlements: [],
    advancedLimits: [],
  },
  {
    key: 'conectividad',
    label: 'Conectividad de entrada',
    help: 'Qué pasa cuando un cliente te escribe: quién responde primero y cuántas conversaciones caben.',
    defaultOpen: true,
    entitlements: [
      { key: 'inbox_enabled', label: 'Recibir conversaciones de clientes' },
      { key: 'ai_inbox_auto_reply_enabled', label: 'La IA responde automático' },
      { key: 'ai_inbox_suggest_enabled', label: 'La IA sugiere respuestas al vendedor' },
      { key: 'email_enabled', label: 'Correo electrónico como canal' },
    ],
    limits: [
      { key: 'max_whatsapp_conversations_monthly', label: 'Conversaciones de WhatsApp al mes' },
      { key: 'max_whatsapp_messages_monthly', label: 'Mensajes de WhatsApp al mes (salen de tu bolsa)' },
    ],
    advancedEntitlements: [],
    advancedLimits: [],
  },
  {
    key: 'campanas',
    label: 'Campañas de salida',
    help: 'Envíos masivos de marketing por WhatsApp, email y SMS.',
    defaultOpen: true,
    entitlements: [
      { key: 'campaigns_enabled', label: 'Crear campañas' },
      { key: 'campaign_scheduling_enabled', label: 'Programar fecha/hora de envío' },
      { key: 'campaign_delivery_enabled', label: 'Enviar campañas' },
      { key: 'campaign_real_delivery_mass_enabled', label: 'Envío masivo real (no solo prueba)' },
      { key: 'campaign_mass_delivery_whatsapp_enabled', label: 'Envío masivo por WhatsApp' },
      { key: 'campaign_mass_delivery_email_enabled', label: 'Envío masivo por Email' },
      { key: 'audiences_enabled', label: 'Segmentar audiencias' },
    ],
    limits: [
      { key: 'max_campaigns', label: 'Campañas activas' },
      { key: 'max_email_sends_monthly', label: 'Emails al mes' },
      { key: 'max_sms_sends_monthly', label: 'SMS al mes' },
      { key: 'max_audience_snapshots_monthly', label: 'Segmentos nuevos al mes' },
    ],
    advancedEntitlements: [
      { key: 'campaign_preview_enabled', label: 'Vista previa antes de enviar' },
      { key: 'campaign_approval_enabled', label: 'Requiere aprobación antes de enviar' },
      { key: 'campaign_versioning_enabled', label: 'Versionado de campañas' },
      { key: 'campaign_preflight_enabled', label: 'Checklist previo al envío' },
      { key: 'campaign_audience_snapshot_enabled', label: 'Fotos de audiencia al programar' },
      { key: 'campaign_ready_for_delivery_enabled', label: 'Marcar campaña lista para enviar' },
      { key: 'campaign_schedule_logs_enabled', label: 'Historial de programación' },
      { key: 'campaign_delivery_planning_enabled', label: 'Planeación de envío' },
      { key: 'campaign_delivery_dry_run_enabled', label: 'Simulacro de envío (sin enviar de verdad)' },
      { key: 'campaign_test_delivery_enabled', label: 'Envío de prueba' },
      { key: 'campaign_delivery_test_send_enabled', label: 'Prueba a un destinatario' },
      { key: 'campaign_delivery_email_test_enabled', label: 'Prueba de email' },
      { key: 'campaign_delivery_whatsapp_test_enabled', label: 'Prueba de WhatsApp' },
      { key: 'campaign_delivery_logs_enabled', label: 'Historial de envíos' },
      { key: 'campaign_production_delivery_enabled', label: 'Envío en producción' },
      { key: 'campaign_real_delivery_enabled', label: 'Envío real (no simulado)' },
      { key: 'campaign_real_delivery_test_send_enabled', label: 'Prueba de envío real' },
      { key: 'contacts_enabled', label: 'Gestión de contactos para campañas' },
      { key: 'campaign_audience_link_enabled', label: 'Vincular audiencia a campaña' },
    ],
    advancedLimits: [
      { key: 'max_campaign_contents_per_campaign', label: 'Variantes de contenido por campaña' },
      { key: 'max_campaign_versions', label: 'Versiones por campaña' },
      { key: 'max_campaign_schedules', label: 'Programaciones activas' },
      { key: 'max_schedules_per_campaign', label: 'Programaciones por campaña' },
      { key: 'max_preflight_runs_monthly', label: 'Checklists al mes' },
      { key: 'max_snapshot_members', label: 'Contactos por segmento' },
      { key: 'max_schedule_window_days_future', label: 'Días de anticipación para programar' },
      { key: 'mass_dispatch_throttle_ms', label: 'Pausa entre envíos (ms)' },
      { key: 'max_real_delivery_attempts_daily', label: 'Intentos de envío real al día' },
    ],
  },
  {
    key: 'automatizaciones',
    label: 'Automatizaciones',
    help: 'Reglas automáticas: quién recibe cada lead y qué avisos se disparan solos.',
    defaultOpen: true,
    entitlements: [
      { key: 'automations_enabled', label: 'Automatizaciones de seguimiento (esperar, reintentar, escalar)' },
      { key: 'triggers_enabled', label: 'Reglas automáticas (si pasa X, hacer Y)' },
      { key: 'trigger_whatsapp_notifications_enabled', label: 'Avisos automáticos por WhatsApp' },
      { key: 'trigger_task_creation_enabled', label: 'Crear tareas automáticas' },
      { key: 'crm_task_functions_enabled', label: 'Funciones en tareas (llamada IA, enlace vendedor, avisos WhatsApp…)' },
      { key: 'assignment_enabled', label: 'Asignación automática de leads' },
      { key: 'assignment_pools_enabled', label: 'Grupos de vendedores (pools)' },
    ],
    limits: [
      { key: 'max_automations', label: 'Automatizaciones activas' },
      { key: 'max_assignment_pools', label: 'Grupos de asignación' },
    ],
    advancedEntitlements: [
      { key: 'assignment_pool_rules_enabled', label: 'Reglas avanzadas de asignación' },
    ],
    advancedLimits: [
      { key: 'max_assignment_pool_rules', label: 'Reglas por grupo de asignación' },
    ],
  },
  {
    key: 'voz',
    label: 'Llamadas de voz',
    help: 'Llamadas entrantes/salientes atendidas por IA o transferidas a un vendedor.',
    defaultOpen: false,
    entitlements: [
      { key: 'voice_enabled', label: 'Llamadas de voz habilitadas' },
      { key: 'voice_inbound_enabled', label: 'Recibir llamadas' },
      { key: 'voice_ai_enabled', label: 'IA contesta llamadas' },
      { key: 'voice_outbound_campaign_enabled', label: 'Llamar por teléfono con IA (saliente)' },
      { key: 'voice_realtime_enabled', label: 'Voz natural en tiempo real (conversación fluida, cuesta más por minuto)' },
    ],
    limits: [
      { key: 'max_voice_minutes_monthly', label: 'Minutos de llamada al mes' },
    ],
    advancedEntitlements: [
      { key: 'voice_telephony_enabled', label: 'Telefonía (número de teléfono real)' },
      { key: 'voice_recording_enabled', label: 'Grabar llamadas' },
      { key: 'voice_transcription_enabled', label: 'Transcribir llamadas' },
    ],
    advancedLimits: [],
  },
  {
    key: 'ia_conocimiento',
    label: 'IA y base de conocimiento',
    help: 'Cuánto puede "leer" y responder tu asistente de IA, y con qué herramientas.',
    defaultOpen: false,
    entitlements: [
      { key: 'ai_enabled', label: 'Asistente de IA habilitado' },
      { key: 'ai_premium_models_enabled', label: 'Modelos de IA premium (más caros, mejor calidad)' },
      { key: 'knowledge_enabled', label: 'Biblioteca de conocimiento (documentos que la IA puede leer)' },
      { key: 'ai_skills_enabled', label: 'Habilidades de IA (guiones/flujos entrenables)' },
      { key: 'ai_skill_templates_enabled', label: 'Plantillas de habilidades' },
      { key: 'ai_skills_simulator_enabled', label: 'Simulador de habilidades' },
      { key: 'ai_tools_enabled', label: 'Herramientas de IA (acciones que la IA puede ejecutar)' },
      { key: 'ai_training_enabled', label: 'Entrenamiento de IA' },
      { key: 'ai_training_simulator_enabled', label: 'Simulador de entrenamiento' },
      { key: 'mcp_enabled', label: 'Conectores MCP (integraciones externas de IA)' },
      { key: 'mcp_sync_enabled', label: 'Sincronización automática de conectores MCP' },
      { key: 'mcp_tool_mapping_enabled', label: 'Mapeo de herramientas MCP' },
    ],
    limits: [
      { key: 'max_ai_tokens_monthly', label: 'Uso de IA al mes (tokens)' },
      { key: 'max_knowledge_assets', label: 'Documentos subidos' },
      { key: 'max_knowledge_storage_mb', label: 'Almacenamiento de documentos (MB)' },
    ],
    advancedEntitlements: [],
    advancedLimits: [
      { key: 'max_ai_requests_monthly', label: 'Solicitudes de IA al mes' },
      { key: 'max_ai_rpm', label: 'Solicitudes de IA por minuto' },
      { key: 'max_knowledge_ai_asks_monthly', label: 'Preguntas a la IA sobre documentos al mes' },
      { key: 'max_knowledge_searches_monthly', label: 'Búsquedas en documentos al mes' },
      { key: 'max_ai_skills', label: 'Habilidades de IA' },
      { key: 'max_ai_skill_simulations_monthly', label: 'Simulaciones de habilidades al mes' },
      { key: 'max_ai_tools', label: 'Herramientas de IA' },
      { key: 'max_ai_tool_versions', label: 'Versiones por herramienta' },
      { key: 'max_ai_tool_validations_monthly', label: 'Validaciones de herramientas al mes' },
      { key: 'max_mcp_servers', label: 'Conectores MCP' },
      { key: 'max_mcp_tools', label: 'Herramientas MCP' },
      { key: 'max_mcp_syncs_daily', label: 'Sincronizaciones MCP al día' },
    ],
  },
  {
    key: 'canales_avanzados',
    label: 'Números y canales avanzados',
    help: 'Para negocios con más de un número de WhatsApp o líneas separadas por uso.',
    defaultOpen: false,
    entitlements: [
      { key: 'channel_purposes_enabled', label: 'Definir para qué sirve cada número' },
      { key: 'multiple_whatsapp_purposes_enabled', label: 'Varios números de WhatsApp' },
      { key: 'channel_capabilities_enabled', label: 'Panel de capacidades por canal' },
    ],
    limits: [
      { key: 'max_whatsapp_instances', label: 'Números de WhatsApp' },
      { key: 'max_voice_instances', label: 'Números de voz' },
    ],
    advancedEntitlements: [
      { key: 'internal_notifications_channel_enabled', label: 'Canal separado para avisos internos' },
      { key: 'voice_purpose_routing_enabled', label: 'Enrutamiento de llamadas por propósito' },
    ],
    advancedLimits: [
      { key: 'max_channel_purpose_assignments', label: 'Asignaciones de propósito por canal' },
      { key: 'max_whatsapp_purpose_assignments', label: 'Asignaciones de propósito de WhatsApp' },
    ],
  },
  {
    key: 'crm_datos',
    label: 'CRM y datos',
    help: 'Contactos, leads y cómo se protegen de duplicados o se exportan.',
    defaultOpen: false,
    entitlements: [
      { key: 'crm_export_enabled', label: 'Exportar datos del CRM' },
      { key: 'crm_duplicate_warnings_enabled', label: 'Avisar de contactos duplicados' },
      { key: 'agenda_enabled', label: 'Agendar citas' },
      { key: 'lead_capture_enabled', label: 'Captura de leads (formularios/QR/orígenes)' },
    ],
    limits: [
      { key: 'max_contacts', label: 'Contactos' },
      { key: 'max_leads_monthly', label: 'Leads nuevos al mes' },
      // 2026-09-01 — el tope de citas existia en el catalogo del backend pero
      // no en ningun grupo curado, asi que caia en la seccion de arrastre del
      // fondo («Existen en el sistema y no aparecian arriba»), lejos del
      // interruptor «Agendar citas» que esta justo aqui arriba. Era editable y
      // nadie lo encontraba. Va donde lo va a buscar quien arma un plan.
      { key: 'max_agenda_appointments', label: 'Citas' },
    ],
    advancedEntitlements: [
      { key: 'crm_contact_persistence_enabled', label: 'Guardar historial completo de contacto' },
    ],
    advancedLimits: [
      { key: 'max_contacts_per_tenant', label: 'Contactos totales del negocio' },
    ],
  },
  {
    key: 'redes_ads',
    label: 'Redes sociales y anuncios',
    help: 'Publicar y responder en Facebook/Instagram/TikTok/LinkedIn, y crear anuncios pagados en esas redes desde CavernicolApp.',
    defaultOpen: false,
    entitlements: [
      { key: 'social_studio_enabled', label: 'Publicaciones (calendario y compositor)' },
      { key: 'social_facebook_enabled', label: 'Facebook (comentarios, mensajes, publicar)' },
      { key: 'social_instagram_enabled', label: 'Instagram (comentarios, mensajes, publicar)' },
      { key: 'meta_ads_enabled', label: 'Anuncios de Meta (Facebook + Instagram)' },
      { key: 'social_tiktok_enabled', label: 'TikTok (próximamente — aún sin conexión de tenant)' },
      { key: 'social_linkedin_enabled', label: 'LinkedIn (próximamente — aún sin conexión de tenant)' },
      { key: 'tiktok_ads_enabled', label: 'Anuncios de TikTok (próximamente)' },
      { key: 'linkedin_ads_enabled', label: 'Anuncios de LinkedIn (próximamente)' },
    ],
    limits: [],
    advancedEntitlements: [],
    advancedLimits: [],
  },
  {
    key: 'orchestrator',
    label: 'Herramientas de IA en producción (Orchestrator)',
    help: 'Permite que la IA ejecute acciones reales dentro de CavernicolApp (agendar, actualizar un lead, etc.), no solo responder texto.',
    defaultOpen: false,
    entitlements: [
      { key: 'orchestrator_enabled', label: 'Orchestrator habilitado' },
      { key: 'orchestrator_sandbox_enabled', label: 'Modo de prueba (sandbox)' },
      { key: 'orchestrator_production_enabled', label: 'Ejecutar acciones reales en producción' },
      { key: 'orchestrator_mcp_execute_enabled', label: 'Ejecutar herramientas MCP desde el Orchestrator' },
    ],
    limits: [],
    advancedEntitlements: [],
    advancedLimits: [],
  },
  {
    key: 'infraestructura',
    label: 'Infraestructura',
    help: 'Si el tenant no trae sus propias cuentas de WhatsApp/Voz/Email, puede usar las de CavernicolApp — a cambio, ese canal deja de tener su propio branding. Se configura en Super Admin > Infraestructura.',
    defaultOpen: false,
    entitlements: [
      { key: 'platform_infrastructure_enabled', label: 'Habilitar infraestructura del administrador' },
      { key: 'platform_email_enabled', label: 'Correo incluido (envía con su dominio, sin traer su propio proveedor)' },
    ],
    limits: [
      { key: 'platform_email_monthly_quota', label: 'Correos al mes con el correo incluido' },
    ],
    advancedEntitlements: [],
    advancedLimits: [],
  },
  {
    key: 'cuenta',
    label: 'Cuenta y almacenamiento',
    help: 'Usuarios, sedes y espacio de almacenamiento del negocio.',
    defaultOpen: true,
    entitlements: [
      { key: 'storage_enabled', label: 'Almacenamiento de archivos (R2/local)' },
      { key: 'conversation_attachments_enabled', label: 'Adjuntos en Conversaciones' },
      { key: 'auto_invite_delivery_enabled', label: 'Enviar invitaciones de equipo automáticamente' },
      { key: 'observability_enabled', label: 'Panel de Estado/Observabilidad' },
    ],
    limits: [
      { key: 'max_users', label: 'Usuarios' },
      { key: 'max_branches', label: 'Sedes/sucursales' },
      { key: 'max_storage_gb', label: 'Almacenamiento total (GB)' },
      { key: 'max_file_size_mb', label: 'Tamaño máximo por archivo (MB)' },
    ],
    advancedEntitlements: [],
    advancedLimits: [
      { key: 'max_api_calls_monthly', label: 'Llamadas a la API al mes' },
    ],
  },
  {
    key: 'web_sites',
    label: 'Sitios web (constructor)',
    help: 'Crear y publicar sitios del negocio con plantillas y editor visual. Todo opt-in; no usa el almacenamiento genérico como límite separado de páginas/sitios.',
    defaultOpen: false,
    entitlements: [
      { key: 'web_builder_enabled', label: 'Constructor Web' },
      { key: 'web_custom_domain_enabled', label: 'Dominio propio' },
      { key: 'web_blog_enabled', label: 'Blog y contenidos' },
      { key: 'web_ai_seo_enabled', label: 'SEO asistido por IA' },
      { key: 'web_dynamic_catalog_enabled', label: 'Catálogos dinámicos del negocio' },
      { key: 'web_custom_code_enabled', label: 'Código personalizado (avanzado)' },
      { key: 'web_tracking_advanced_enabled', label: 'Tracking avanzado' },
      { key: 'web_ai_site_builder_enabled', label: 'Asistente de IA para construir/importar sitios' },
      { key: 'web_cro_enabled', label: 'Optimización de conversión con IA (A/B testing)' },
    ],
    limits: [
      { key: 'max_websites', label: 'Sitios web' },
      { key: 'max_web_pages_per_site', label: 'Páginas por sitio' },
      { key: 'max_web_custom_domains', label: 'Dominios propios' },
      { key: 'max_web_revisions', label: 'Versiones guardadas' },
      { key: 'max_web_form_submissions_monthly', label: 'Envíos de formularios web al mes' },
      { key: 'max_ai_site_generations_monthly', label: 'Sitios generados/importados con IA al mes' },
    ],
    advancedEntitlements: [],
    advancedLimits: [],
  },
  {
    key: 'real_estate',
    label: 'Desarrollos Inmobiliarios (ERP y operación)',
    help: 'Plan de pagos y cobranza, apartado de unidades, Mesa de Servicio de garantías y gestión condominal — solo aplica a negocios configurados como vertical Desarrollos Inmobiliarios.',
    defaultOpen: false,
    entitlements: [
      { key: 'real_estate_erp_enabled', label: 'ERP de cobranza (plan de pagos + apartado de unidades)' },
      { key: 'real_estate_warranty_enabled', label: 'Mesa de Servicio (tickets de garantía con triage IA)' },
      { key: 'real_estate_condo_enabled', label: 'Gestión condominal (cuotas + reserva de amenidades)' },
    ],
    limits: [],
    advancedEntitlements: [],
    advancedLimits: [],
  },
];

// Flat lookups derived from PLAN_GROUPS, for places that show a single
// entitlement/limit key outside the grouped editor (e.g. plan card summary).
export const LIMIT_LABELS = {};
export const ENTITLEMENT_LABELS = {};
for (const group of PLAN_GROUPS) {
  for (const { key, label } of [...(group.limits || []), ...(group.advancedLimits || [])]) LIMIT_LABELS[key] = label;
  for (const { key, label } of [...(group.entitlements || []), ...(group.advancedEntitlements || [])]) ENTITLEMENT_LABELS[key] = label;
}


// S205/S221 — lo que el dueño VE es lo que el tenant RECIBE.
// Desde 2.9.484 la ausencia en el plan significa NO (Claude, paso 3).
// Hidratar en True volvía a regalar producto al pulsar Guardar.
export const UNLIMITED = -1;
// Espejo de CORP_UNLIMITED_SENTINEL del backend (entitlements.py). Los límites
// efectivos ya salen normalizados: «ilimitado» viaja como este número gigante,
// no como -1. La pantalla tiene que reconocer AMBOS para mostrar «Ilimitado»
// y no «999999999».
export const UNLIMITED_SENTINEL = 999999999;

const ENTITLEMENT_DEFAULT_FALSE = new Set([
  'ai_premium_models_enabled',
  'platform_infrastructure_enabled',
  'voice_realtime_enabled',
  'conversation_attachments_enabled',
  'social_tiktok_enabled',
  'social_linkedin_enabled',
  'tiktok_ads_enabled',
  'linkedin_ads_enabled',
  'web_builder_enabled',
  'web_custom_domain_enabled',
  'web_custom_code_enabled',
  'web_tracking_advanced_enabled',
  'web_blog_enabled',
  'web_ai_seo_enabled',
  'web_dynamic_catalog_enabled',
  'web_ai_site_builder_enabled',
  'web_cro_enabled',
]);

export const LIMIT_DEFAULTS = {
  max_whatsapp_instances: 2,
  max_voice_instances: 2,
  max_storage_gb: 5,
  max_file_size_mb: 100,
  max_websites: 0,
  max_web_custom_domains: 0,
  max_web_form_submissions_monthly: 0,
  max_ai_site_generations_monthly: 5,
  platform_email_monthly_quota: 500,
};

export function allPlanEntitlementKeys() {
  const keys = [];
  for (const g of PLAN_GROUPS) {
    for (const { key } of [...(g.entitlements || []), ...(g.advancedEntitlements || [])]) {
      keys.push(key);
    }
  }
  return keys;
}

export function allPlanLimitKeys() {
  const keys = [];
  for (const g of PLAN_GROUPS) {
    for (const { key } of [...(g.limits || []), ...(g.advancedLimits || [])]) {
      keys.push(key);
    }
  }
  return keys;
}

export function hydratePlanForm(plan = {}) {
  const ents = { ...(plan.included_entitlements || {}) };
  for (const k of allPlanEntitlementKeys()) {
    if (ents[k] === undefined || ents[k] === null) {
      ents[k] = false;
    }
  }
  const lims = { ...(plan.included_limits || {}) };
  for (const [k, d] of Object.entries(LIMIT_DEFAULTS)) {
    if (lims[k] === undefined || lims[k] === null || lims[k] === '') lims[k] = d;
  }
  return {
    included_entitlements: ents,
    included_limits: lims,
    default_ai_model_key: ents.default_ai_model_key || '',
  };
}

export function isUnlimited(v) {
  const n = Number(v);
  return v === UNLIMITED || v === '-1' || n === -1 || n < 0 || n >= UNLIMITED_SENTINEL;
}

export function formatLimit(v) {
  if (isUnlimited(v)) return 'Ilimitado';
  if (v === undefined || v === null || v === '') return '—';
  return String(v);
}
